import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import ProjectsAdmin from '../components/admin/ProjectsAdmin';
import SkillsAdmin from '../components/admin/SkillsAdmin';
import BlogAdmin from '../components/admin/BlogAdmin';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('projects');

  return (
    <AdminContainer>
      <Header>
        <Title>Admin Dashboard</Title>
        <Subtitle>Manage your portfolio content</Subtitle>
      </Header>

      <TabsContainer>
        <TabButton 
          $active={activeTab === 'projects'} 
          onClick={() => setActiveTab('projects')}
        >
          Projects
        </TabButton>
        <TabButton 
          $active={activeTab === 'skills'} 
          onClick={() => setActiveTab('skills')}
        >
          Skills
        </TabButton>
        <TabButton 
          $active={activeTab === 'blog'} 
          onClick={() => setActiveTab('blog')}
        >
          Blog
        </TabButton>
      </TabsContainer>

      <ContentContainer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        {activeTab === 'projects' && <ProjectsAdmin />}
        {activeTab === 'skills' && <SkillsAdmin />}
        {activeTab === 'blog' && <BlogAdmin />}
      </ContentContainer>
    </AdminContainer>
  );
};

const AdminContainer = styled.div`
  padding: 120px 20px 50px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.div`
  margin-bottom: 30px;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: var(--accent);
  margin-bottom: 10px;
`;

const Subtitle = styled.h2`
  font-size: 1.2rem;
  color: var(--text-secondary);
  font-weight: 400;
`;

const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid var(--text-secondary);
  margin-bottom: 30px;
  overflow-x: auto;
  
  @media (max-width: 600px) {
    padding-bottom: 10px;
  }
`;

const TabButton = styled.button`
  padding: 12px 24px;
  background: transparent;
  border: none;
  color: ${props => props.$active ? 'var(--accent)' : 'var(--text-primary)'};
  font-size: 1rem;
  cursor: pointer;
  border-bottom: 2px solid ${props => props.$active ? 'var(--accent)' : 'transparent'};
  transition: all 0.3s ease;
  white-space: nowrap;
  
  &:hover {
    color: var(--accent);
  }
`;

const ContentContainer = styled(motion.div)`
  background: var(--secondary);
  border-radius: 10px;
  padding: 30px;
  min-height: 500px;
`;

export default Admin;